import { Splide, SplideSlide } from '@splidejs/react-splide'
import i18next from 'i18next'
import { useCallback, useRef } from 'react'
import { GrFormNext, GrFormPrevious } from 'react-icons/gr'
import { useParams, useSearchParams } from 'react-router-dom'
import { OpportunitiesMineralsOptions } from '../../config/splide-slide-options'
import { useTranslation } from 'react-i18next'

export default function OpportunitiesMineralsSlider({ minerals }) {
  const { lng } = useParams()
  const { t } = useTranslation()
  const [searchParams, setSearchParams] = useSearchParams()

  const mineralsSilderRef = useRef(null)

  const handleNavigation = useCallback(
    (direction) => {
      const adjustment = lng === 'en' ? (direction === 1 ? '+1' : '-1') : direction === 1 ? '-1' : '+1'
      mineralsSilderRef.current.splide.go(adjustment)
    },
    [lng],
  )

  function handleOnClickMineral(mineralId) {
    if (mineralId == searchParams.get('MINERAL')) {
      searchParams.delete('MINERAL')
    } else {
      searchParams.set('MINERAL', mineralId)
    }
    setSearchParams(searchParams)
  }

  return (
    <div
      data-aos-delay="500"
      data-aos="fade-up"
      className="mb-4 w-full"
    >
      <div className="mb-2 flex items-center justify-start gap-2">
        <button
          onClick={() => handleNavigation(1)}
          aria-label={t('NEXT')}
          className="hover:border-secondary-600 border-muted-300 flex items-center border-2 bg-white p-2 hover:bg-light ltr:rotate-180"
        >
          <GrFormNext className="h-5 w-5" />
        </button>
        <button
          onClick={() => handleNavigation(-1)}
          aria-label={t('PREVIOUS')}
          className="hover:border-secondary-600 border-muted-300 flex items-center border-2 bg-white p-2 hover:bg-light ltr:rotate-180"
        >
          <GrFormPrevious className="h-5 w-5" />
        </button>
      </div>
      <div dir="ltr">
        <Splide
          ref={mineralsSilderRef}
          options={OpportunitiesMineralsOptions}
          aria-label="Minerals"
        >
          {minerals &&
            minerals?.map((mineral) => {
              return (
                <SplideSlide
                  className="cursor-pointer rounded-none"
                  key={mineral.id}
                >
                  <div
                    onClick={() => handleOnClickMineral(mineral.id)}
                    className={`flex border-2 ${lng == 'ar' ? '' : 'flex-row-reverse'} group items-center ${searchParams.get('MINERAL') == mineral.id ? 'border-secondary-600 bg-light' : 'hover:border-secondary-600 border-muted-300'} `}
                  >
                    <div className={`bg-light ${lng == 'ar' ? 'border-l-2' : 'border-r-2'} ${searchParams.get('MINERAL') == mineral.id ? 'border-secondary-600 bg-muted-300' : 'group-hover:border-secondary-600 border-muted-300'}`}>
                      <img
                        className="h-16 w-16 p-2"
                        src={`${process.env.REACT_APP_API_BASE_URL}/storage/minerals/${mineral.image}`}
                        alt={mineral[`name_${lng}`]}
                      />
                    </div>
                    <h3 className="p-2 px-4 text-center font-bold capitalize">{mineral[`name_${lng}`]}</h3>
                  </div>
                </SplideSlide>
              )
            })}
        </Splide>
      </div>
    </div>
  )
}
